import { Flame, Globe2, HeartPulse, Sparkles, Timer, Wheat } from "lucide-react";
import { Eyebrow, Reveal } from "@/components/Reveal";

const BENEFITS = [
  { icon: HeartPulse, title: "Heart-Healthy Fats", text: "Naturally balanced MUFA & PUFA profiles support cardiovascular wellness.", span: "lg:col-span-3" },
  { icon: Sparkles, title: "Rich Antioxidants", text: "Curcumin, sesamol and tocopherols survive cold pressing intact.", span: "lg:col-span-3" },
  { icon: Wheat, title: "Unrefined Aroma", text: "The true smell and taste of the seed — a retail differentiator.", span: "lg:col-span-2" },
  { icon: Flame, title: "High Smoke Point", text: "Stable performance for everyday frying and sautéing.", span: "lg:col-span-2" },
  { icon: Timer, title: "Extended Shelf Life", text: "Nitrogen-flushed packaging protects quality across long transit.", span: "lg:col-span-2" },
  { icon: Globe2, title: "B2B & Retail Ready", text: "Flexi-tanks for processors, private label bottles for shelves.", span: "lg:col-span-6" },
];

export default function Benefits() {
  return (
    <section data-testid="benefits-section" className="bg-sand py-20 md:py-28">
      <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-16">
        <Reveal className="max-w-2xl">
          <Eyebrow>The Tsugiva Advantage</Eyebrow>
          <h2 className="mt-3 font-serif text-3xl font-semibold leading-tight text-ink sm:text-4xl lg:text-5xl">
            Nutrition your customers can taste
          </h2>
        </Reveal>
        <div className="mt-14 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-6">
          {BENEFITS.map((b, i) => (
            <Reveal key={b.title} delay={i * 0.06} className={b.span}>
              <div
                data-testid={`benefit-card-${b.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                className="group flex h-full items-start gap-5 rounded-2xl border border-stone2 bg-white p-7 transition-all duration-500 hover:-translate-y-1.5 hover:border-gold hover:shadow-[0_20px_50px_-18px_rgba(212,139,22,0.35)]"
              >
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-gold/10 text-gold transition-colors duration-500 group-hover:bg-gold group-hover:text-white">
                  <b.icon size={22} />
                </span>
                <div>
                  <h3 className="font-serif text-lg font-semibold text-ink">{b.title}</h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-smoke">{b.text}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
